// Auto-generated normalizer for table: Cat_Estados
export function catEstadosNormalize(row) {
  return {
    idEstado: row.idEstado ?? row.IdEstado ?? row['IdEstado'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
